import loadable from '@loadable/component';

export const AddPaymentMethodPageContainerLoadable = loadable(
  () => import('./AddPaymentMethodPageContainer'),
  { resolveComponent: (module) => module.AddPaymentMethodPageContainer },
);
